import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ChapterMarker } from './shared';
import { BROWN } from '../assets';

gsap.registerPlugin(ScrollTrigger);

export default function Ch8Reveal() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: { trigger: '.reveal-wrap', start: 'top 85%', end: 'top 15%', scrub: 1 },
      });
      tl.fromTo(
        '.reveal-img',
        { clipPath: 'inset(42% 38% 42% 38%)', scale: 1.3, filter: 'blur(8px) brightness(1.5)' },
        { clipPath: 'inset(0% 0% 0% 0%)', scale: 1, filter: 'blur(0px) brightness(1)', ease: 'none' }
      );
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section id="ch-8" ref={sectionRef} data-testid="chapter-8" className="relative bg-[#0A0A0A] px-6 md:px-16 py-28 md:py-40">
      <ChapterMarker num="08" title="The Finished Jacket" />

      <div className="text-center mb-12 md:mb-16">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="font-accent text-[10px] text-[#8C5A35] block mb-5"
        >
          1,200 stitches · 14 panels · 47 checks later — the same hide you watched arrive
        </motion.span>
        <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight">
          The jacket <span className="italic text-[#B89B72]">is born.</span>
        </h2>
      </div>

      <div className="reveal-wrap relative max-w-2xl mx-auto">
        <div className="reveal-img relative aspect-[2/3] overflow-hidden will-change-[clip-path]">
          <img src={BROWN.full} alt="The finished brown suede bomber, worn" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/40 via-transparent to-transparent" />
        </div>
        <span className="absolute -bottom-5 right-0 font-accent text-[9px] text-[#525252]">THE SUEDE BOMBER PT-2411 — WORN, TOKYO SHOOT</span>
      </div>
    </section>
  );
}
